import { useCallback, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Button } from "@/components/ui/button";
import { ShieldX, LogOut, RefreshCw } from "lucide-react";

/** Signed in, but not an internal staff account. Nothing here is for them. */
export const NotDashboardAccount = () => {
  const { user, logout, refreshSession } = useAuth();
  const [checking, setChecking] = useState(false);

  // A promotion made seconds ago can hide behind the five-minute session
  // cookie cache, so a reload may show this page again. This reads past it.
  const checkAgain = useCallback(async () => {
    setChecking(true);
    try {
      await refreshSession();
    } finally {
      setChecking(false);
    }
  }, [refreshSession]);

  return (
    <div className="flex min-h-svh flex-col items-center justify-center bg-background p-6">
      <div className="mx-auto flex max-w-md flex-col items-center text-center">
        <div className="mb-6 flex size-20 items-center justify-center rounded-2xl bg-destructive/10 text-destructive">
          <ShieldX className="size-10" />
        </div>
        <h1 className="mb-2 text-2xl font-semibold text-foreground">
          Not a dashboard account
        </h1>
        <p className="mb-6 text-muted-foreground">
          This is the EverTutor internal dashboard. It is for internal staff
          accounts only. Your account is a product account and cannot open it.
        </p>
        {user && (
          <p className="mb-6 rounded-lg border border-border bg-muted/50 px-4 py-2 text-sm text-muted-foreground">
            Signed in as{" "}
            <span className="font-medium text-foreground">{user}</span>
          </p>
        )}
        <div className="flex gap-3">
          <Button onClick={() => void checkAgain()} disabled={checking} className="gap-2">
            <RefreshCw className={checking ? "size-4 animate-spin" : "size-4"} />
            {checking ? "Checking..." : "Check again"}
          </Button>
          <Button variant="destructive" onClick={logout} className="gap-2">
            <LogOut className="size-4" />
            Sign Out
          </Button>
        </div>
      </div>
    </div>
  );
};
